const Compare = {
    name: 'compare',
    globalName: 'Compare',
    el: '#compare',
    data: function() {
        return {
            debug: true,
        };
    },
    mounted: function() {},
    methods: {
        test: function() {
            console.log('success!');
        },
        add: function (id, iblockid) {
            if (this.debug) {
                console.log('Добвление товара в сравнение ('+id+')');
            }
            $.ajax({
                url: window.SITE_DIR + 'ajax.php',
                data: {
                    'id': id,
                    'iblockid': iblockid,
                    'action': 'setCompare',
                },
                type: 'post',
                dataType: 'json',
                success: this.handlerResponse
            });
        },
        del: function (id, iblockid) {
            if (this.debug) {Basket.
                console.log('Удаления товара из сравнение ('+id+')');
            }
            $.ajax({
                url: window.SITE_DIR + 'ajax.php',
                data: {
                    'id': id,
                    'iblockid': iblockid,
                    'action': 'delCompare',
                },
                type: 'post',
                dataType: 'json',
                success: this.handlerResponse
            });
        },
        handlerResponse(response) {
            const compareCounterNode = document.querySelector('.comparisons-count');

            if (compareCounterNode) {
                let count = 0;
                Object.values(response).forEach(el => {
                    console.log(el.ITEMS);
                    if (el.ITEMS && Object.values(el.ITEMS).length) {
                        count += Object.values(el.ITEMS).length;
                        $('.comparisons-link').removeClass('black');
                        $('.comparisons-link').addClass('orange');
                        compareCounterNode.classList.add('count-active');
                    } else {
                        count = 0;
                        $('.comparisons-link').removeClass('orange');
                        $('.comparisons-link').addClass('black');
                        compareCounterNode.classList.remove('count-active');
                    }
                });

                compareCounterNode.textContent = count;
            }
        }
    },
    // components: App.components
};
module.exports = Compare;
